module.exports = __webpack_public_path__ + "montserrat-regular-webfont.8f2822b73b5f9c106c6f.woff";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/@okta/okta-signin-widget/dist/font/montserrat-regular-webfont.woff
// module id = ../../../../@okta/okta-signin-widget/dist/font/montserrat-regular-webfont.woff
// module chunks = 11